module.exports = __webpack_public_path__ + "img/Gitimoji512@2x.f110d8b0.png";